import React, { useEffect, useMemo, useRef, useState } from "react";

const DrawerSelect = ({
  value,
  onChange,
  options = [],
  placeholder = "Select",
  disabled = false,
  searchable = false,
  className = "",
}) => {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const containerRef = useRef(null);

  const selectedOption = useMemo(
    () => options.find((o) => String(o.value) === String(value)),
    [options, value]
  );

  const filtered = useMemo(() => {
    if (!searchable || !query) return options;
    const q = query.toLowerCase();
    return options.filter((o) => String(o.label || "").toLowerCase().includes(q));
  }, [options, searchable, query]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!containerRef.current) return;
      if (!containerRef.current.contains(e.target)) setOpen(false);
    };
    if (open) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  return (
    <div ref={containerRef} className={`relative ${className}`}>
      <button
        type="button"
        disabled={disabled}
        onClick={() => setOpen((s) => !s)}
        className={`w-full h-[52px] px-3 pr-12 border rounded focus:outline-none focus:ring-2 focus:ring-[#1E3A8A] text-left ${
          selectedOption ? "text-black border-gray-300" : "text-gray-400 border-gray-300"
        } ${disabled ? "opacity-60 cursor-not-allowed" : ""}`}
      >
        {selectedOption ? selectedOption.label : placeholder}
      </button>
      <span className="pointer-events-none absolute inset-y-0 right-3 flex items-center text-gray-400">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </span>

      {open && (
        <div className="absolute z-50 mt-1 w-full bg-white border border-gray-200 rounded shadow-lg max-h-64 overflow-auto">
          {searchable && (
            <div className="p-2 border-b border-gray-100">
              <input
                autoFocus
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="Search..."
                className="w-full h-[36px] px-3 border border-gray-200 rounded focus:outline-none focus:ring-1 focus:ring-[#1E3A8A]"
              />
            </div>
          )}
          <ul className="py-1">
            {filtered.length === 0 && (
              <li className="px-3 py-2 text-sm text-gray-500">No options</li>
            )}
            {filtered.map((opt) => (
              <li
                key={opt.value}
                className={`px-3 py-2 text-sm cursor-pointer hover:bg-gray-50 ${
                  String(opt.value) === String(value) ? "bg-gray-50" : ""
                }`}
                onClick={() => {
                  onChange?.(opt.value);
                  setOpen(false);
                  setQuery("");
                }}
              >
                {opt.label}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default DrawerSelect;


